import styled from "styled-components";

export const SectionButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex:1;
`;
